var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back-to-top-wrapper"},[_c('div',{staticClass:"back-to-top"},[_c('img',{attrs:{"src":require(`@/assets/img/backtotop_icon.png`)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }